import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

const DropdownPortal = ({ children, targetRef }: any) => {
  const [style, setStyle] = useState({});

  useEffect(() => {
    if (targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      setStyle({
        position: "absolute",
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        zIndex: 9999,
      });
    }
  }, [targetRef]);

  return ReactDOM.createPortal(
    <div style={style}>{children}</div>,
    document.body
  );
};

export default DropdownPortal;
